import { Type } from "@sinclair/typebox";
export const MAX_FREEMIUM_EQUIPMENT_OPTIONS = 3;
export const MAX_FREEMIUM_TRAINING_STYLES = 3;
const frequency = Type.KeyOf(Type.Object({
    not_at_all: Type.Number(),
    few_month: Type.Number(),
    once_week: Type.Number(),
    "2_to_3_week": Type.Number(),
    "4_plus_week": Type.Number(),
}));
export const freemiumTrainingStyleSchema = Type.Union([
    Type.Literal("traditional_strength"),
    Type.Literal("functional_strength"),
    Type.Literal("yoga"),
    Type.Literal("hiit"),
    Type.Literal("cardio"),
    Type.Literal("calisthenics"),
]);
export const freemiumTrainerGenderSchema = Type.Union([
    Type.Literal("male"),
    Type.Literal("female"),
    Type.Literal("no_preference"),
]);
export const freemiumPrimaryGoalSchema = Type.Union([
    Type.Literal("boost_cardio"),
    Type.Literal("build_strength"),
    Type.Literal("lose_fat"),
    Type.Literal("improve_health"),
]);
export const freemiumDaysPerWeekSchema = Type.Union([
    Type.Literal(3),
    Type.Literal(5),
]);
export const freemiumDurationMinutesSchema = Type.Union([
    Type.Literal(30),
    Type.Literal(60),
]);
export const freemiumExperienceLevelSchema = Type.Union([
    Type.Literal("beginner"),
    Type.Literal("novice"),
    Type.Literal("intermediate"),
    Type.Literal("advanced"),
]);
export const biologicalSexSchema = Type.Union([
    Type.Literal("male"),
    Type.Literal("female"),
    Type.Literal("other"),
    Type.Literal("prefer_not_to_say"),
]);
export const preCopilotEquipmentSchema = Type.Union([
    Type.Literal("none"),
    Type.Literal("few_at_home"),
    Type.Literal("apartment_gym"),
    Type.Literal("full_gym_access"),
]);
export const surveyDataSchema = Type.Object({
    height: Type.Number(),
    weight: Type.Number(),
    weightSystem: Type.String(),
    age: Type.Number(),
    gender: Type.String(),
    biologicalSex: biologicalSexSchema,
    devicePlatform: Type.KeyOf(Type.Object({ ios: Type.Number(), android: Type.Number() })),
    preCopilotActivityFrequency: frequency,
    preCopilotTrainerExperience: Type.Boolean(),
    preCopilotWorkoutFrequency: frequency,
    preCopilotEquipment: preCopilotEquipmentSchema,
    ownsSmartWatch: Type.Boolean(),
    tagsIdentity: Type.Array(Type.String()),
    tagsExperience: Type.Array(Type.String()),
    tagsSpecialties: Type.Array(Type.String()),
    tagsCommunicationStyle: Type.Array(Type.Any()),
    tagsObWindowsPreferred: Type.Array(Type.String()),
    tagsGoals: Type.Array(Type.String()),
    tagsAddOns: Type.Array(Type.String()),
    organizationLocationId: Type.Optional(Type.String()),
    freemiumTrainingStyle: Type.Array(freemiumTrainingStyleSchema),
    freemiumExperienceLevel: freemiumExperienceLevelSchema,
    /**
     * Must be a key from EquipmentType enum in
     * packages/features/src/legacy/interfaces/equipment.ts
     * ex. dumbbell,pullup_bar, jumpRope, etc
     */
    freemiumEquipment: Type.Array(Type.String()),
    freemiumTrainerGender: freemiumTrainerGenderSchema,
    freemiumPrimaryGoal: freemiumPrimaryGoalSchema,
    freemiumDaysOfWeek: Type.Array(Type.Number()),
    freemiumPlanId: Type.String(),
});
//# sourceMappingURL=survey.js.map